import AppRoutes from "./types/app";
import AuthRoutes from "./types/auth";
import PrivateRoutes from "./types/private";
import ProductRoutes from "./types/products/routes";
const DefaultRoute = "/";

let allRoutes = [
  ...AppRoutes,
  ...AuthRoutes,
  ...PrivateRoutes,
  ...PrivateRoutes,
];

export {
  AppRoutes,
  AuthRoutes,
  DefaultRoute,
  PrivateRoutes,
  allRoutes,
  ProductRoutes,
};
